<!-- test navigation bar -->
<div class="nav-gutter">
   <nav class="navbar navbar-expand-lg navbar-light p-0">
     <div class="container-fluid">
       <a class="navbar-brand text-primary"
          routerLink="/"> EzyPortal </a>
       <button class="navbar-toggler"
               type="button"
               data-toggle="collapse"
               data-target="#navbarSupportedContent"
               aria-controls="navbarSupportedContent"
               aria-expanded="false"
               aria-label="Toggle navigation">
         <span class="navbar-toggler-icon fa fa-bars"></span>
       </button>
 
       <div class="collapse navbar-collapse"
            id="navbarSupportedContent">
         <ul class="navbar-nav mx-auto">
           <li class="nav-item"
               *hasPermission="['dasboard.view']">
             <a (click)="routeDashboard()" class="nav-link"> Dashboard</a>
           </li>
           <li class="nav-item">
             <a class="nav-link" routerLink="/users"
                *ngIf="isSuperAdmin$ | async"
                routerLinkActive="active">Users</a>
           </li>
           <li class="nav-item dropdown">
             <a class="nav-link dropdown-toggle"
                href="#"
                id="ordersDropDown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                *hasPermission="['usage.view']">Usage</a>
             <div class="dropdown-menu"
                  aria-labelledby="ordersDropDown">
               <a routerLink="/usage/referrals"
                  *hasPermission="['usage.view']">Referrals</a>
               <a routerLink="/usage/farmmanager"
                  *hasPermission="['usage.view']">Farm Manager</a>
               <a routerLink="/usage/betterextension"
                  *hasPermission="['usage.view']">Better Extension</a>
               <a routerLink="/usage/shop"
                  *hasPermission="['usage.view']">Agrishop</a>
               <a routerLink="/usage/producemarket"
                  *hasPermission="['usage.view']">Produce Market</a>
               <a routerLink="/usage/ezycredits"
                  *hasPermission="['usage.view']">Ezycredits</a>
               <ng-container>
                 <a routerLink="/ezyusers"
                    *ngIf="countryName === 'uganda'">EzyAgric Users</a>
               </ng-container>
             </div>
           </li>
           <li class="nav-item dropdown">
             <a class="nav-link dropdown-toggle"
                href="#"
                id="appContent"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">App Content</a>
             <div class="dropdown-menu"
                  aria-labelledby="appContent">
               <a routerLink="/agrishop"
                  *hasPermission="['inputs.view']">AgriShop</a>
               <a routerLink="/services"
                  *hasPermission="['services.view']">Services</a>
               <a routerLink="/crop"
                  *hasPermission="['crops.view']">Crops</a>
               <a routerLink="/"
                  *hasPermission="['diary.view']">Diary</a>
               <a routerLink="/mobile-new-market-info"
                  *hasPermission="['markets.view']">Markets</a>
               <a routerLink="/videos"
                  *hasPermission="['video.view']">Videos</a>
             
               <a routerLink="/financial-lit-topics"
                  *hasPermission="['finacial-literacy.view']">Financial&nbsp;Literacy</a>
               <a routerLink="/animal"
                  *hasPermission="['livestock.view']">Livestock</a>
               <a [routerLink]="['/agrishop', 'promotions']"
                  *hasPermission="['promotions.view']">Promotions</a>
               <a [routerLink]="['/agrishop', 'banners']"
                  *hasPermission="['banners.view']">Banners
               </a>
               <a routerLink="/push-notifications"
               *hasPermission="['notifications.view']">
              Push Notifications</a>
             </div>
           </li>
 
           <li class="nav-item dropdown"
               *hasPermission="['orders.view']">
             <a class="nav-link dropdown-toggle"
                href="#"
                id="ordersDropDown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                *ngIf="countryName === 'uganda'">Orders</a>
             <div class="dropdown-menu"
                  aria-labelledby="ordersDropDown">
               <a [routerLink]="['/agrishop', 'orders']">Inputs</a>
               <a routerLink="/services/orders/orders">Services</a>
               <a routerLink="/services/orders/garden-mapping">Garden Mapping</a>
               <a routerLink="/services/orders/soil-testing">Soil Testing</a>
               <a routerLink="/services/orders/farm-plan">Farm Plan</a>
             </div>
           </li>
 
           <li class="nav-item"
               *hasPermission="['contacts.view']">
             <a routerLink="/contacts" class="nav-link"> Contacts</a>
           </li>
         </ul>
         <br />
         <ul class="nav navbar-nav ml-auto">
        
           <li class="nav-item dropdown">
             <div class="nav-link text-bold"
                  style="cursor: pointer;"
                  data-toggle="dropdown">
 
                   
              <div class="d-inline-block verticle-align-middle pr-4">
                <span class=" text-dark">{{ firstname }}</span>
                <small class="d-block "> {{ userRole }}</small>
              </div>
              <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.6937 2.21836L11.2919 0.651606L6.33965 5.44383L1.77572 0.354334L0.254324 1.82977L6.21969 8.4968L12.6937 2.21836Z" fill="#C4C4C4"/>
                </svg>
                
             </div>
             <div class="dropdown-menu dropdown-menu-right">
               <a class="dropdown-item text-dark"
                  routerLink="/change-password">
                 <i class="fas fa-lock mr-2 "></i> Change Password
               </a>
               
               <a class="dropdown-item text-dark logout"
                  (click)="logOut()">
                 <i class="fas fa-power-off mr-2 "></i> Log Out
               </a>
             </div>
           </li>
         </ul>
       </div>
     </div>
   </nav>
 </div>
